import { render, staticRenderFns } from "./permissoes-sistema.vue?vue&type=template&id=37aa7a0c&scoped=true&"
import script from "./permissoes-sistema.vue?vue&type=script&lang=js&"
export * from "./permissoes-sistema.vue?vue&type=script&lang=js&"
import style0 from "./permissoes-sistema.vue?vue&type=style&index=0&id=37aa7a0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa7a0c",
  null
  
)

export default component.exports